import React from 'react'
import '../Css/Footer.css';
const Footer = () => {
    return (
        <footer>
            <hr className='hr_line'/>
            <div className='footer_wrapper'>
                <div className='footer'>
                    Copyright © {(new Date().getFullYear())} - All Rights Reserved.
                </div>
                <div className='contact_detail'>
                    For Enquiries Call: <a href='tel:9716279387'>+91-9716279387</a>
                </div>
            </div>
        </footer>
    )
}

export default Footer